import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-58">
      <div className="container mx-auto px-4 max-w-5xl relative z-10 text-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-61">
            ⏰ EL PRECIO CIERRA PRONTO
          </h2>
          <p className="text-xl text-gray-400 mb-12" data-id="element-62">
            Elegí tu plan y empezá hoy mismo.
          </p>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-12" data-id="element-63">
          <FadeIn delay={0.1} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-64">
            <a href="https://fegion.shop/cart/46824945516683:1" className="flex flex-col items-center justify-center p-8 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-colors h-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Kit Adulto de Rescate por $19.990 ARS" data-id="element-65">
              <span className="text-lg font-bold text-white mb-2" data-id="element-66">
                🩹 KIT ADULTO DE RESCATE
              </span>
              <span className="text-sm text-gray-400 mb-6 text-center" data-id="element-67">
                6 Módulos + 4 Bonos · Todas las crisis
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-68">
                <span className="text-gray-500 line-through text-lg" data-id="element-69">
                  $54.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-70">
                  $19.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-white border border-white/20 hover:bg-white/5 transition-colors uppercase tracking-wider text-sm" data-id="element-71">
                🛡️ Quiero el Kit + mis 4 Bonos — Acceso en 2 minutos
              </div>
            </a>
          </FadeIn>

          <FadeIn delay={0.2} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-72">
            <a href="https://fegion.shop/cart/46824994341003:1" className="flex flex-col items-center justify-center p-8 bg-gold rounded-2xl hover:bg-gold/90 transition-colors shadow-lg h-full relative focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Kit Adulto de Rescate + Deck Táctico por $27.990 ARS" data-id="element-73">
              <span className="text-lg font-bold text-background mb-2" data-id="element-74">
                🏆 KIT ADULTO DE RESCATE + DECK TÁCTICO ⭐
              </span>
              <span className="text-sm text-background/80 font-medium mb-6 text-center" data-id="element-75">
                6 Módulos + 4 Bonos + 50 Tarjetas
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-76">
                <span className="text-background/50 line-through text-lg" data-id="element-77">
                  $72.000
                </span>
                <span className="text-3xl font-bold text-background" data-id="element-78">
                  $27.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-sm" data-id="element-79">
                → QUIERO EL KIT COMPLETO + DECK TÁCTICO
              </div>
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-80">
          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400" data-id="element-81">
            <div className="flex items-center gap-2" data-id="element-82">
              <span className="text-gold" data-id="element-83">🔒</span>
              <span data-id="element-84">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-85">
              <span className="text-gold" data-id="element-86">⚡</span>
              <span data-id="element-87">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-88">
              <span className="text-gold" data-id="element-89">✓</span>
              <span data-id="element-90">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-91">
              <span className="text-gold" data-id="element-92">💳</span>
              <span data-id="element-93">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}